/* eslint-disable no-lone-blocks */
import axios from 'axios';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import React, { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { AddButton, ReplaceButton } from '@src/components/buttons';
import AddMobCampaignForm from '@src/components/forms/addMobBanner.form';
import { useAuth } from '@src/contexts/authContext';
import { convertToJPG } from '@src/utils';

const url = `${process.env.REACT_APP_API_URL}/admin`;
const urls = `${process.env.REACT_APP_API_URL}/event/get-event`;

export default function UpdateMobCampaign() {
  const { auth } = useAuth();
  const { adsId } = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState([]);
  const [previewUrl, setPreviewUrl] = useState([]);

  const [inputAds, setInputAds] = useState({
    file: [],
    _id: [],
    banner_type: [''],
    ads_link: [''],
    event_id: [''],
    event_link: [''],
  });

  const [updateAds, setUpdateAds] = useState({
    ads_title: '',
    file: [],
    file_id: [],
    ads_link: [''],
    event_id: [''],
    event_link: [''],
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    ads_status: ['ongoing', 'coming_soon', 'expired'],
    ads_type: '',
    banner_type: [''],
    sorts: 0,
  });

  const [listEvents, setListEvents] = useState([]);
  const [status, setStatus] = useState('listed');
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${urls}?event_status=${status}`, {
          headers: {
            Authorization: `Bearer ${auth?.idToken}`,
          },
        });

        setListEvents(response.data);
      } catch (error) {
        console.log('Error', error.message);
      }
    };
    if (auth?.idToken) {
      fetchData();
    }
  }, [auth, status]);

  const [open, setOpen] = React.useState(false);

  async function updateMobBanner() {
    const uploadFormData = new FormData();
    const filesArray = inputAds.file || [];

    await Promise.all(
      filesArray.map(async (file, index) => {
        let processedFile = file.file ?? file;

        if (processedFile instanceof File) {
          if (processedFile.type === 'image/png') {
            processedFile = await convertToJPG(processedFile, 2);
          }
        } else if (typeof processedFile === 'string') {
          const response = await fetch(processedFile);
          const blob = await response.blob();

          let cleanName =
            processedFile
              .split('/')
              .pop()
              ?.replace(/(resized-\d+-)+/g, '') || 'image.jpg';

          if (cleanName.length > 100) {
            const ext = cleanName.split('.').pop() || 'jpg';
            cleanName = `banner-${Date.now()}.${ext}`;
          }

          processedFile = new File([blob], cleanName, { type: blob.type });
        }

        uploadFormData.append('files', processedFile);
        if (file._id) uploadFormData.append(`file_id[${index}]`, file._id);
        if (file.ads_link)
          uploadFormData.append(`ads_link[${index}]`, file.ads_link);
        if (file.event_link)
          uploadFormData.append(`event_link[${index}]`, file.event_link);
        if (file.event_id)
          uploadFormData.append(`event_id[${index}]`, file.event_id);
        if (file.banner_type)
          uploadFormData.append(`banner_type[${index}]`, file.banner_type);
      }),
    );

    uploadFormData.append('ads_title', inputAds.ads_title || '');
    uploadFormData.append('start_date', inputAds.start_dates || '');
    uploadFormData.append('end_date', inputAds.end_dates || '');
    uploadFormData.append('start_time', inputAds.start_times || '');
    uploadFormData.append('end_time', inputAds.end_times || '');
    uploadFormData.append('ads_status', inputAds.ads_status || '');
    uploadFormData.append('ads_type', inputAds.ads_type || '');
    uploadFormData.append('sorts', inputAds.sorts ?? '');

    try {
      const response = await axios.put(
        `${url}/mobile-banners/${adsId}`,
        uploadFormData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${auth.idToken}`,
          },
        },
      );

      setInputAds(response.data);
      toast.success('Banner updated successfully', {
        position: 'top-center',
        autoClose: 1000,
      });
      setTimeout(() => window.location.reload(), 1500);
      navigate('/announcement-marketing');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update banner.', {
        position: 'top-center',
        autoClose: 3000,
      });
      console.error(error);
    }
  }

  function handleFileChange(e, index) {
    const file = e.target.files[0];
    if (!file) return;

    setInputAds((prev) => {
      const updated = { ...prev };
      updated.file = [...(prev.file || [])];

      if (updated.file[index]?._id || updated.file[index]?.file) {
        updated.file[index] = {
          ...(updated.file[index] || {}),
          file,
        };
      } else {
        updated.file.push({ file });
      }

      return updated;
    });

    setPreviewUrl((prev) => {
      const updatedPreview = [...(prev || [])];
      updatedPreview[index] = URL.createObjectURL(file);
      return updatedPreview;
    });
  }

  function updateItemBanner(index) {
    const fileObj = inputAds?.file?.[index];
    const actualFile = fileObj?.file || fileObj?.originFileObj;

    if (!(actualFile instanceof File)) {
      console.warn('No valid file found to upload');
      return;
    }

    const uploadFormData = new FormData();
    uploadFormData.append('first_image', actualFile);
    uploadFormData.append(
      'banner_id',
      fileObj.banner_id || inputAds?.banner_id,
    );
    uploadFormData.append('ads_link', fileObj.ads_link || '');
    uploadFormData.append('event_link', fileObj.event_link || '');
    uploadFormData.append('event_id', fileObj.event_id || '');
    uploadFormData.append('banner_type', fileObj.banner_type || 'ads');

    axios
      .post(`${url}/file-mob-banner`, uploadFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        const fileIds = response.data?.fileIds;
        if (Array.isArray(fileIds) && fileIds.length > 0) {
          setInputAds((prev) => {
            const updated = { ...prev };
            updated.file = [...(prev.file || [])];
            updated.file[index] = {
              ...(updated.file[index] || {}),
              _id: fileIds[0],
              file: undefined,
            };
            return updated;
          });
          console.log('File uploaded:', fileIds[0]);
        } else {
          console.warn('fileIds array is missing or empty:', fileIds);
        }
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
      });
  }

  const handleItemFileChange = (e, index) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      setPreviewUrl((prev) => {
        const updated = [...prev];
        updated[index] = reader.result;
        return updated;
      });

      const newFiles = [...(inputAds.file || [])];
      newFiles[index] = {
        ...newFiles[index],
        file,
      };

      const updatedInputAds = {
        ...inputAds,
        file: newFiles,
      };

      setInputAds(updatedInputAds);
      // updateItemBanner(inputAds, updatedInputAds);
    };

    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < (inputAds.file?.length || 0); i++) {
      const fileObj = inputAds.file[i];
      if (fileObj && fileObj.file && !fileObj._id) {
        updateItemBanner(inputAds, i);
      }
    }
    updateMobBanner();
    // handleOpenModal();
  };

  const handleAdsLinkChange = (index, value) => {
    setInputAds((prevInputAds) => {
      const updatedFileArray = [...prevInputAds.file];
      if (updatedFileArray[index]) {
        updatedFileArray[index] = {
          ...updatedFileArray[index],
          ads_link: value,
        };
      }
      return { ...prevInputAds, file: updatedFileArray };
    });
  };

  const handleEventLinkChange = (index, value) => {
    setInputAds((prevInputAds) => {
      const updatedFileArray = [...prevInputAds.file];
      if (updatedFileArray[index]) {
        updatedFileArray[index] = {
          ...updatedFileArray[index],
          event_link: value,
        };
      }
      return { ...prevInputAds, file: updatedFileArray };
    });
  };

  const fetchBannerData = async () => {
    try {
      const response = await axios.get(`${url}/mobile-banners/${adsId}`, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      });
      setInputAds(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDeleteItemBanner = async (id) => {
    try {
      await axios.delete(`${url}/file-mob-banner/${id}`, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      });

      setInputAds((prev) => {
        if (!Array.isArray(prev.file)) return prev;
        return {
          ...prev,
          file: prev.file.filter((item) => item._id !== id), // hapus object file terkait
        };
      });

      setPreviewUrl((prev) => {
        if (!Array.isArray(prev)) return [];
        return prev.filter((_, idx) => inputAds.file[idx]?._id !== id);
      });

      setSelectedFile((prev) => {
        if (!Array.isArray(prev)) return [];
        return prev.filter((_, idx) => inputAds.file[idx]?._id !== id);
      });

      toast.success('Item deleted successfully', {
        position: 'top-center',
        autoClose: '1000',
      });
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete item', {
        position: 'top-center',
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    fetchBannerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, adsId]);

  const handleCloseModal = () => {
    setOpen(false);
    navigate('/announcement-marketing');
  };

  const handleBack = () => {
    navigate('/announcement-marketing');
  };

  return (
    <div className='py-8 px-8'>
      <Box sx={{ width: '100%' }}>
        <div className='flex  justify-between'>
          <Button
            sx={{
              textTransform: 'none',
              paddingLeft: 0,
            }}
            className='py-6 px-6 font-bold text-purple-500'
            variant='text'
            // eslint-disable-next-line react/jsx-no-bind
            onClick={handleBack}
          >
            Back
          </Button>
          <Button
            sx={{
              textTransform: 'none',
              margin: 1,
              height: '50px',
              width: '150px',
            }}
            className='rounded-md border border-cyan-600 px-6 font-bold text-cyan-600'
            variant='outlined'
            // eslint-disable-next-line react/jsx-no-bind
            onClick={() => {
              handleSave();
            }}
            onNavigate={() => {
              navigate('/announcement-marketing');
            }}
          >
            Save
          </Button>
        </div>
      </Box>
      <br />
      <Box
        className=' rounded-xl px-4'
        sx={{ width: '100%', height: '170px', backgroundColor: 'white' }}
      >
        <AddMobCampaignForm
          inputAds={inputAds}
          setInputAds={setInputAds}
          updateAds={updateAds}
          setUpdateAds={setUpdateAds}
        />
      </Box>

      <div className='py-2 px-4'>
        <div className='py-2 text-sm font-bold text-gray-500'>
          Home Screen Carousel Banner
        </div>
        <div className='text-xs text-gray-400'>(Best size 358 x 198)</div>
      </div>
      <br />
      <Box
        sx={{
          width: 'auto',
          backgroundColor: 'white',
          overflowX: 'auto',
          overflowY: 'hidden',
          scrollbarWidth: 'thin',
          scrollbarColor: 'gray',
        }}
        className='rounded-xl py-4 px-4'
      >
        <div className='flex' style={{ width: 'calc(408px * 4)' }}>
          {[0, 1, 2, 3].map((index) => {
            const fileData = inputAds?.file?.[index] || {};
            const currentType = fileData.banner_type || '';

            return (
              <Box
                key={index}
                sx={{
                  width: '390px',
                  height: 'auto',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    margin: 2,
                    width: '358px',
                    height: '200px',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                  className='flex justify-center bg-gray-300'
                >
                  <div>
                    <input
                      type='file'
                      accept='image/*'
                      onChange={(e) => {
                        if (!fileData?.file) {
                          handleItemFileChange(e, index);
                        } else {
                          handleFileChange(e, index);
                        }
                      }}
                      name='files'
                      multiple
                      style={{ display: 'none' }}
                      id={`upload-file-input-${index}`}
                    />

                    {((Array.isArray(previewUrl) && previewUrl[index]) ||
                      fileData?.file) && (
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          position: 'relative',
                        }}
                      >
                        <img
                          src={
                            Array.isArray(previewUrl) && previewUrl[index]
                              ? previewUrl[index]
                              : fileData?.file || ''
                          }
                          alt=''
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                          }}
                        />
                      </div>
                    )}

                    <label htmlFor={`upload-file-input-${index}`}>
                      {fileData?._id || fileData?.file ? (
                        <ReplaceButton />
                      ) : (
                        <AddButton />
                      )}
                      <br />
                    </label>

                    <Button
                      sx={{
                        textTransform: 'none',
                        position: 'absolute',
                        top: '50%',
                        left: '70%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                      }}
                      variant='contained'
                      component='span'
                      className='bg-red-500 text-xs font-bold'
                      onClick={() =>
                        handleDeleteItemBanner(fileData?._id || '')
                      }
                    >
                      Remove
                    </Button>
                    <br />
                  </div>
                </Box>

                {/* Banner Type */}
                <div className='col-span-4 px-4'>
                  <label className='block py-2 text-sm font-medium leading-6 text-gray-600'>
                    Banner type*
                  </label>
                  <FormControl>
                    <Select
                      id={`type-${index}`}
                      style={{ height: '48px', width: '360px', fontSize: 14 }}
                      onChange={(e) => {
                        const updatedFiles = [...(inputAds.file || [])];
                        updatedFiles[index] = {
                          ...updatedFiles[index],
                          banner_type: e.target.value,
                        };
                        setInputAds({ ...inputAds, file: updatedFiles });
                      }}
                      className='rounded-md text-gray-600'
                      value={currentType}
                      displayEmpty
                    >
                      <MenuItem disabled value=''>
                        <em style={{ color: '#8C8C8C' }}>Select type</em>
                      </MenuItem>
                      <MenuItem value='ads'>Ads</MenuItem>
                      <MenuItem value='event'>Event</MenuItem>
                    </Select>
                  </FormControl>

                  {/* ADS */}
                  {currentType === 'ads' && (
                    <div className='mt-2 py-4'>
                      <input
                        placeholder='Enter link'
                        style={{ width: '360px' }}
                        value={fileData.ads_link || ''}
                        onChange={(e) =>
                          handleAdsLinkChange(index, e.target.value)
                        }
                        className='font-poppins block w-full rounded-md border-0 bg-white px-2 py-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                      />
                    </div>
                  )}

                  {/* EVENT */}
                  {currentType === 'event' && (
                    <>
                      <div className='py-6'>
                        <FormControl>
                          <Select
                            style={{
                              height: '48px',
                              width: '360px',
                              fontSize: 14,
                            }}
                            onChange={(e) => {
                              const updatedFiles = [...(inputAds.file || [])];
                              updatedFiles[index] = {
                                ...updatedFiles[index],
                                event_id: e.target.value,
                              };
                              setInputAds({ ...inputAds, file: updatedFiles });
                            }}
                            value={fileData.event_id || ''}
                            className='rounded-md text-gray-600'
                            displayEmpty
                          >
                            <MenuItem disabled value=''>
                              <em style={{ color: '#8C8C8C' }}>Select event</em>
                            </MenuItem>
                            {listEvents?.map((option) => (
                              <MenuItem key={option._id} value={option._id}>
                                {option.event_title}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <input
                          placeholder='Enter link'
                          value={fileData.event_link || ''}
                          onChange={(e) =>
                            handleEventLinkChange(index, e.target.value)
                          }
                          style={{ width: '360px' }}
                          className='font-poppins block w-full rounded-md border-0 bg-white px-2 py-3.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
                        />
                      </div>
                    </>
                  )}
                </div>
              </Box>
            );
          })}
        </div>
        <br />
        <div className='px-6 text-xs text-gray-300'>*image is required</div>
      </Box>

      <br />
      <br />
      <br />
      <Dialog open={open} onClose={handleCloseModal}>
        <DialogTitle>Save Successful</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The ads has been updated successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
